export default "/images/17.png?b6b3186ae161a0bc0210672971ed41d9";